<template>
	<div class="tab-container">
		<div class="tab-content">
			<h1>진담헤어 디자이너 이용약관</h1>
			<br />

			<section>
				<h2>제1조 (목적)</h2>
				<p>
					본 약관은 진담헤어(이하 “회사”)가 운영하는 미용서비스 예약 중개 플랫폼(이하 “서비스”)에 등록한 디자이너(이하 “디자이너”)의 권리와 의무, 책임 및 이용
					조건을 규정함을 목적으로 합니다.
				</p>
			</section>

			<section>
				<h2>제2조 (정의)</h2>
				<p>① “디자이너”란 유효한 미용사 자격증을 보유하고 회사의 심사를 통해 플랫폼에 입점하여 고객에게 시술을 제공하는 독립사업자입니다.</p>
				<p>② “고객”이란 디자이너의 시술을 예약하고 이용하는 플랫폼 사용자입니다.</p>
				<p>③ “서비스”란 고객과 디자이너 간의 예약, 결제, 시술 진행, 리뷰 등의 과정을 중개하고 지원하는 회사의 앱, 웹사이트, 기능 일체를 말합니다.</p>
				<p>④ “입점”이란 디자이너가 회사의 서비스 내에 자신의 프로필을 등록하고, 고객 예약을 수락할 수 있는 상태를 의미합니다.</p>
			</section>

			<section>
				<h2>제3조 (입점 조건 및 자격 요건)</h2>
				<p>① 디자이너는 유효한 미용사 자격증을 소지하고 있어야 하며, 경력, 사진, 포트폴리오 등 진실한 정보를 기반으로 입점 신청을 해야 합니다.</p>
				<p>② 허위 또는 조작된 정보를 제출하거나 타인의 정보를 도용한 경우, 계정은 즉시 삭제되며 법적 책임이 발생할 수 있습니다.</p>
				<p>③ 디자이너는 계약 전 회사의 약관 및 입점 계약 내용을 충분히 숙지하고 동의해야 합니다.</p>
			</section>

			<section>
				<h2>제4조 (시술 책임 및 면책 조항)</h2>
				<p>① 디자이너는 고객에게 제공하는 모든 시술의 품질과 결과에 대해 민·형사상 책임을 전적으로 부담합니다.</p>
				<p>② 회사는 단순 중개자로서, 고객과 디자이너 간의 시술 결과 또는 사고에 대해 법적 책임을 지지 않습니다.</p>
				<p>③ 고객에게 예상 가능한 부작용, 염모제 및 화학 제품의 성분, 시술 방식, 소요 시간 등을 사전 안내하고, 고객 동의를 받아야 합니다.</p>
				<p>④ 시술 중 발생한 부작용, 탈모, 알레르기 반응, 스타일 불만족 등으로 인한 민원은 디자이너가 직접 응대하고 해결하여야 합니다.</p>
			</section>

			<section>
				<h2>제5조 (예약 관리 및 노쇼 방지)</h2>
				<p>① 디자이너는 자신이 설정한 근무 시간에 대해 예약을 수락하거나 거절할 수 있으며, 수락한 예약은 성실히 이행해야 합니다.</p>
				<p>② 무단 노쇼, 빈번한 예약 거절, 지각 등 고객의 피해를 유발하는 행동이 반복되면 계정이 제한되거나 해지될 수 있습니다.</p>
				<p>③ 예약 관리 책임은 디자이너 본인에게 있으며, 앱 내 관리 기능을 통해 정기적으로 확인해야 합니다.</p>
			</section>

			<section>
				<h2>제6조 (콘텐츠 등록 및 정보관리)</h2>
				<p>① 디자이너는 시술 이미지, 시술설명, 가격정보, 프로필 등을 정확하고 사실에 기반해 등록해야 하며, 과장 광고, 허위 내용 등록은 금지됩니다.</p>
				<p>② 등록된 콘텐츠에 대한 저작권 및 초상권 침해가 발생하지 않도록 주의해야 하며, 발생 시 모든 법적 책임은 디자이너에게 있습니다.</p>
				<p>③ 회사는 서비스 품질 향상을 위해 등록 콘텐츠에 대해 검토, 수정 요청, 노출 제한 등의 조치를 취할 수 있습니다.</p>
			</section>

			<section>
				<h2>제7조 (정산 및 수수료)</h2>
				<p>① 디자이너가 수행한 시술에 대해 고객이 결제한 금액에서 회사가 정한 수수료를 공제한 후, 나머지 금액을 디자이너에게 지급합니다.</p>
				<p>② 수수료율, 정산 주기, 지급일 등은 플랫폼 공지 및 개별 계약서에 따르며, 회사는 이를 사전 고지 후 변경할 수 있습니다.</p>
				<p>③ 세금신고 및 부가세 납부 의무는 디자이너 본인에게 있으며, 회사는 세무 대행이나 원천징수를 하지 않습니다.</p>
			</section>

			<section>
				<h2>제8조 (리뷰 및 평가)</h2>
				<p>① 고객은 시술 후 리뷰를 남길 수 있으며, 리뷰는 서비스 내에서 공개됩니다.</p>
				<p>② 디자이너는 리뷰에 대해 정중하고 객관적으로 답변할 수 있으며, 리뷰 조작, 협박, 명예훼손성 대응은 제한 조치의 사유가 됩니다.</p>
				<p>③ 회사는 허위리뷰나 악성 리뷰에 대해 자체적으로 검토하여 삭제 또는 비노출 처리할 수 있으나, 법적 책임은 지지 않습니다.</p>
			</section>

			<section>
				<h2>제9조 (서비스 해지 및 탈퇴)</h2>
				<p>① 디자이너는 언제든지 탈퇴를 요청할 수 있으며, 회사는 정산 완료 후 계정을 비활성화할 수 있습니다.</p>
				<p>② 탈퇴 시점에 남아 있는 예약 건, 고객 민원, 환불 등은 디자이너가 모두 처리 완료해야 합니다.</p>
				<p>③ 다음의 경우 회사는 별도의 통보 없이 계정을 정지하거나 해지할 수 있습니다:</p>
				<ul>
					<li><p>- 반복적인 노쇼 또는 예약 파기</p></li>
					<li><p>- 고객에게 시술 사고를 유발한 경우</p></li>
					<li><p>- 무면허 시술, 불법 화학제품 사용</p></li>
					<li><p>- 허위정보 등록, 명예훼손 등 플랫폼 질서를 위협하는 행위</p></li>
				</ul>
			</section>

			<section>
				<h2>제10조 (분쟁 해결 및 책임 귀속)</h2>

				<p>① 고객과의 민원, 시술 결과로 인한 분쟁은 디자이너가 직접 해결하여야 하며, 회사는 사실확인 자료만 제공할 수 있습니다.</p>
				<p>② 고객이 손해배상, 고소, 시술 피해를 제기할 경우, 법적 책임은 디자이너에게 있으며, 회사는 책임을 지지 않습니다.</p>
			</section>

			<section>
				<p>시행일자: 2025년 8월 8일</p>
				<p>버전: 1.0</p>
				<p>부칙 본 약관은 2025년 8월 8일부터 적용됩니다. 이전 버전의 약관은 본 약관으로 대체됩니다.</p>
			</section>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'TermServiceDesigner',
		props: {},
		data: () => ({}),
		mounted: function() {},
		methods: {},
	};
</script>

<style scoped>
	.tab-container {
		margin: 20px;
	}

	.tab-content {
		padding: 20px;
		text-align: left;
	}

	.tab-content h2 {
		margin-top: 0;
	}

	h1 {
		font-size: 24px;
	}

	h2 {
		font-size: 20px;
		margin-top: 20px;
	}

	p,
	li {
		font-size: 16px;
		text-indent: 20px;
		list-style: none;
	}

	ul {
		margin-left: 40px;
	}
</style>
